import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import useHashArray from "../../../../hooks/useHashArray";
import {
  getCityListActionHandler,
  getCountryListActionHandler,
  getStateListActionHandler,
  getWorkOfficeListActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/userManagementActionHandler";
import { userManagementForm } from "../../../../utils/mainTabs/admin/userManagement/userManagementForm";
import { selectUserLocationSchema } from "../../../../utils/mainTabs/admin/userManagement/userManagementFormSchema";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import PreviousIcon from "../../../Common/SvgIcons/CommonIcons/PreviousIcon";
import classes from "./SelectUserLocation.module.scss";
import { FormattedMessage } from "react-intl";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorAction } from "../../../../store/actions/actionCreators/errorActionCreator";
import Modal from "../../../Common/Modal/Modal";

const SelectUserLocation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const {
    userDetailsPath,
    additionalDetailsPath,
    userLocationPath,
    editUserPath,
    formValues,
    setFormValues,
    countryList,
    setCountryList,
    stateList,
    setStateList,
    cityList,
    setCityList,
    storeList,
    setStoreList,
    addUserPath,
  } = useOutletContext();
  const [fields, setFields] = useState([]);
  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { userManagementReducer } = adminStateReducer;
  const {
    getCountryListLoader,
    getStateListLoader,
    getCityListLoader,
    getWorkOfficeListLoader,
  } = userManagementReducer;

  const methods = useForm({
    defaultValues: { ...formValues },
    resolver: yupResolver(selectUserLocationSchema),
  });

  const {
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
    getValues,
    setValue,
    watch,
  } = methods;
  const {
    userLocation: { formFields },
    userDetails: { name: userDetailsName },
  } = userManagementForm;

  const { hashTable: storeHashTable } = useHashArray(
    formValues?.Store,
    "StoreId",
    true
  );

  // useEffect(() => {
  //   if (countryList?.length === 0) {
  //     dispatch(getCountryListActionHandler()).then((countryList) => {
  //       setCountryList(countryList);
  //       setValue("Country", "1433");
  //     });
  //   }
  // }, [dispatch, countryList?.length]);

  // useEffect(() => {
  //   if (formValues?.Country) {
  //     setValue("Country", "1433");
  //   }
  // }, [countryList?.length, setValue]);
  useEffect(() => {
    if (userLocationPath === `${editUserPath}/selectUserLocation`) {
      if (formValues?.Country && stateList?.length > 0)
        setValue("State", formValues?.State);
      if (formValues?.Country && formValues?.State && cityList?.length > 0)
        setValue("City", formValues?.City);
    }
  }, [dispatch, editUserPath, userLocationPath]);

  useEffect(() => {
    if (formValues?.Country && formValues?.State && cityList?.length === 0) {
      dispatch(getCityListActionHandler(formValues?.State)).then((cityList) => {
        setCityList(cityList);
      });
    }
  }, [
    dispatch,
    cityList?.length,
    formValues?.Country,
    formValues?.State,
    formValues?.Country,
  ]);
  useEffect(() => {
    if (
      formValues?.City &&
      // formValues?.Store?.length > 0 &&
      storeList?.length === 0 &&
      storeHashTable
    ) {
      dispatch(getWorkOfficeListActionHandler(formValues?.City)).then(
        (storeList) => {
          let UpdatedStoreList = storeList.map((store) => {
            return storeHashTable[store?.StoreId]
              ? { ...store, checked: true }
              : store;
          });
          setStoreList(UpdatedStoreList);
        }
      );
    }
  }, [
    dispatch,
    storeHashTable,
    formValues?.City,
    storeList?.length,
    formValues?.Store?.length,
  ]);

  const handleSelectCountry = useCallback(
    (e) => {
      let countryId = e.target.value;
      setValue("Store", []);
      setValue("State", null);
      setValue("City", null);
      setCityList([]);
      setStoreList([]);
      dispatch(getStateListActionHandler(countryId)).then((stateList) => {
        setStateList(stateList);
      });
    },
    [dispatch, setValue, setStateList]
  );
  const handleSelectState = useCallback(
    (e) => {
      let stateId = e.target.value;
      setValue("Store", []);
      setValue("City", null);
      setStoreList([]);
      dispatch(getCityListActionHandler(stateId)).then((cityList) => {
        setCityList(cityList);
      });
    },
    [dispatch, setValue]
  );
  const handleSelectCity = useCallback(
    (e) => {
      let cityId = e.target.value;
      setValue("Store", []);
      dispatch(getWorkOfficeListActionHandler(cityId)).then((storeList) => {
        setStoreList(storeList);
      });
    },
    [dispatch, setValue]
  );

  useEffect(() => {
    let formArgs = {
      countryList,
      handleSelectCountry,
      getCountryListLoader,
      stateList,
      handleSelectState,
      getStateListLoader,
      cityList,
      handleSelectCity,
      getCityListLoader,
      storeList,
      setStoreList,
      getWorkOfficeListLoader,
    };
    const fieldsList = formFields(formArgs);
    setFields(fieldsList);
  }, [
    formFields,
    countryList,
    handleSelectCountry,
    getCountryListLoader,
    stateList,
    handleSelectState,
    getStateListLoader,
    cityList,
    handleSelectCity,
    getCityListLoader,
    storeList,
    getWorkOfficeListLoader,
    formValues?.Country,
  ]);

  const handleBackToUserDetails = () => {
    let userLocationData = getValues();
    setFormValues({ ...formValues, ...userLocationData });
    navigate(userDetailsPath);
  };
  const [updateLocationValues, setUpdateLocationValues] = useState(false);
  const [submitData, setSubmitData] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [userLocationValues, setUserLocationValues] = useState(false);
  const onSubmit = (data) => {
    setSubmitData(data);
    setConfirmModal(true);
    if (
      userLocationPath == `${editUserPath}/selectUserLocation` &&
      (formValues?.Country != data.Country ||
        formValues?.State != data.State ||
        formValues?.City != data.City ||
        formValues.Store.length != data.Store.length)
    ) {
      if (
        data?.Country &&
        (data?.State == null || data?.City == null || data.Store.length == 0)
      ) {
        setUserLocationValues(true);
      } else {
        setUpdateLocationValues(true);
      }
    } else if (data?.Country) {
      if (data?.State == null || data?.City == null || data.Store.length == 0) {
        setUserLocationValues(true);
      } else {
        setFormValues({ ...formValues, ...data });
        navigate(additionalDetailsPath);
      }
    } else {
      setFormValues({ ...formValues, ...data });
      navigate(additionalDetailsPath);
    }
  };
  const handleSubmitModal = (data) => {
    setFormValues({ ...formValues, ...data });
    navigate(additionalDetailsPath);
  };
  const handleSubmitNullValuesModal = (data) => {
    const formData = {
      Country: null,
      State: null,
      City: null,
      Store: [],
    };
    setFormValues({ ...formValues, ...formData });
    navigate(additionalDetailsPath);
  };
  const handleReset = () => {
    reset();
    setStoreList([]);
    setStateList([]);
    setCityList([]);
    if (location.pathname?.includes(addUserPath)) {
      let UpdatedStoreList = storeList.map((store) => {
        return { ...store, checked: false };
      });
      //setStoreList(UpdatedStoreList);
    } else {
      dispatch(getWorkOfficeListActionHandler(formValues?.City)).then(
        (storeList) => {
          let UpdatedStoreList = storeList.map((store) => {
            return storeHashTable[store?.StoreId]
              ? { ...store, checked: true }
              : store;
          });
          setStoreList(UpdatedStoreList);
        }
      );
    }
  };
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.selectUserLocation__form}
      >
        <div className={classes.selectUserLocation__form__fields}>
          {fields.map((field) => {
            return (
              <div
                className={classes.selectUserLocation__form__fields__field}
                key={field?.key}
              >
                <Input
                  label={field?.label}
                  name={field?.name}
                  placeholder={field?.placeholder}
                  labelColor={field?.labelColor}
                  error={errors?.[field?.name]?.message}
                  type={field?.type}
                  fieldName={field?.fieldName}
                  fieldValue={field?.fieldValue}
                  valueArr={field?.valueArr}
                  onChange={field?.onChange}
                  height={field?.height}
                  width={field?.width}
                  searchTagsList={field?.searchTagsList}
                  handleTagList={field?.handleTagList}
                  disabled={field?.disabled}
                  loading={field?.loading}
                  searchable={field?.searchable}
                />
              </div>
            );
          })}
        </div>
        <div className={classes.selectUserLocation__form__footer}>
          <div
            className={classes.selectUserLocation__form__footer__backButton}
            onClick={handleBackToUserDetails}
          >
            <PreviousIcon fill={colors.theme} />
            <div
              className={
                classes.selectUserLocation__form__footer__backButton__linkMedium
              }
            >
              {userDetailsName}
            </div>
          </div>
          <div
            className={classes.selectUserLocation__form__footer__rightSection}
          >
            {(isDirty || isValid) && (
              <div
                className={
                  classes.selectUserLocation__form__footer__rightSection__clearAll
                }
                onClick={handleReset}
              >
                <FormattedMessage id="CLEAR_ALL_TXT" />
              </div>
            )}
            <Button
              label={"Save & Next"}
              small
              dark
              type="submit"
              disabled={!isValid}
            />
          </div>
        </div>
        <Modal
          heading={"Shotclasses Message"}
          isOpen={updateLocationValues}
          toggle={() => setUpdateLocationValues(false)}
          buttonLabel1="Yes"
          buttonLabel2="No"
          width={"40"}
          height={"25"}
          handleSubmit={() => {
            handleSubmitModal(submitData, setConfirmModal);
          }}
        >
          <div className={classes.selectUserLocation__form__modal}>
            You are about to change the user's existing associations and it may
            change future notifications and assignments. Do you want to Proceed
            ?
          </div>
        </Modal>
        <Modal
          heading={"Shotclasses Message"}
          isOpen={userLocationValues}
          toggle={() => setUserLocationValues(false)}
          buttonLabel1="Yes"
          buttonLabel2="No"
          width={"40"}
          height={"25"}
          handleSubmit={() => {
            handleSubmitNullValuesModal(submitData, setConfirmModal);
          }}
        >
          <div className={classes.selectUserLocation__form__modal}>
            You have to select all fields for worker Location. Incomplete
            information will not be saved.Click Yes to proceed ?
          </div>
        </Modal>
      </form>
    </FormProvider>
  );
};

export default SelectUserLocation;
